import { ChatProvider } from '../contexts/ChatContext';
import { useChat } from '../hooks/useChat';
import { type PartialDesignBrief } from '../types/briefSchema';
import { ChatInputArea } from './ChatInputArea';
import { ChatMessageList } from './ChatMessageList';
import type { Message } from '../types/chat';

export interface ChatInterfaceProps {
    designBrief: PartialDesignBrief;
    onBriefUpdate: (brief: PartialDesignBrief) => void;
    /** Called when the user clicks "Fill out a form instead". When undefined the prompt is hidden. */
    onSwitchToForm?: () => void;
    /** Server-side chat history used to hydrate the conversation on mount. */
    initialMessages?: Message[];
    initialBriefComplete?: boolean;
    onChatStarted?: () => void;
    /** Called when the user clicks "Review your brief" on the completion card */
    onReview: () => void;
    printProductMpvId: string;
    initialMaxMessages?: number | null;
}

export function ChatInterface({
    designBrief,
    onBriefUpdate,
    onSwitchToForm,
    initialMessages,
    initialBriefComplete,
    onChatStarted,
    onReview,
    printProductMpvId,
    initialMaxMessages,
}: ChatInterfaceProps) {
    const chat = useChat({
        designBrief,
        onBriefUpdate,
        initialMessages,
        initialBriefComplete,
        onChatStarted,
        initialMaxMessages,
    });

    return (
        <ChatProvider value={chat} printProductMpvId={printProductMpvId} designBrief={designBrief}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // Fill the parent container. ChatBrief wraps this in a
                    // viewport-height flex column alongside MultiStepTopBar, so
                    // the chat naturally takes the remaining space below the
                    // top bar (and below the site bookends header above it).
                    height: '100%',
                    minHeight: 0,
                }}
            >
                <ChatMessageList onReview={onReview} />
                <ChatInputArea onSwitchToForm={onSwitchToForm} onReview={onReview} />
            </div>
        </ChatProvider>
    );
}
